/* @flow */
/* eslint no-unused-vars: 0 */

import React from 'react';

class ProductStock extends React.PureComponent {
  constructor(props) {
    super(props);

    this.outOfStockButton = null;
    this.deliveryDateButton = null;

    this.setOutOfStockButtonRef = element => {
      this.outOfStockButton = element;
    };

    this.setDeliveryDateButtonRef = element => {
      this.deliveryDateButton = element;
    };

    this.state = {
      stockDate: false,
    };

    this.handleOutOfStock = this.handleOutOfStock.bind(this);
  }

  handleOutOfStock() {
    const { stockDate } = this.state;

    this.setState(
      {
        stockDate: !stockDate,
      },
      () => {
        this.deliveryDateButton
          ? this.deliveryDateButton.focus()
          : this.outOfStockButton.focus();
      },
    );
  }

  render() {
    const { branchStocks, collectionSet, getBranchStock, product } = this.props;
    const {
      b2b_next_delivery_date: stockEta,
      b2b_stock_level: stockLevel,
      collection_only: collectionOnly,
      delivery_only: deliveryOnly,
      id,
      minimum_order: minimumOrder,
    } = product;
    const { stockDate } = this.state;

    if (
      collectionOnly === false &&
      stockLevel === 0 &&
      stockDate &&
      stockEta !== 'Unknown Delivery Date'
    ) {
      return (
        <button
          className="product-listings__stock-box product-listings__stock-box--full-width fl fl-col jc-c"
          onClick={this.handleOutOfStock}
          ref={this.setDeliveryDateButtonRef}>
          <strong className="product-listings__stock-title">Delivery</strong>
          <span className="product-listings__stock-level">
            Available from <strong>{stockEta}</strong>
          </span>
        </button>
      );
    }

    if (
      collectionOnly === false &&
      stockLevel === 0 &&
      stockDate &&
      stockEta === 'Unknown Delivery Date'
    ) {
      return (
        <button
          className="product-listings__stock-box product-listings__stock-box--full-width fl fl-col jc-c"
          onClick={this.handleOutOfStock}
          ref={this.setDeliveryDateButtonRef}>
          <strong className="product-listings__stock-title">Delivery</strong>
          <span className="product-listings__stock-level product-listings__stock-level--no-date">
            <strong>{stockEta}</strong>
          </span>
        </button>
      );
    }

    return (
      <div className="product-listings__stock fl jc-sb">
        {collectionOnly === false ? (
          stockLevel === 0 ? (
            <button
              className="product-listings__stock-box product-listings__stock-box--out-of-stock fl fl-col jc-c"
              onClick={this.handleOutOfStock}
              ref={this.setOutOfStockButtonRef}>
              <strong className="product-listings__stock-title">
                Delivery
              </strong>
              <span className="product-listings__stock-level product-listings__stock-level--out-of-stock fl ai-c">
                <i className="icon icon-info-sign"></i>
                <strong>Out of Stock</strong>
              </span>
            </button>
          ) : (
            <div className="product-listings__stock-box fl fl-col jc-c">
              <strong className="product-listings__stock-title">
                Delivery
              </strong>
              <div className="product-listings__stock-level">
                <strong>{stockLevel}</strong> in stock
              </div>
            </div>
          )
        ) : (
          <div className="product-listings__stock-box fl fl-col jc-c">
            <strong className="product-listings__stock-title">Delivery</strong>
            <div className="product-listings__stock-level">Not Available</div>
          </div>
        )}
        {deliveryOnly === false ? (
          <div className="product-listings__stock-box fl fl-col jc-c">
            <strong className="product-listings__stock-title">
              Collection
            </strong>
            {!collectionSet ? (
              <div className="product-listings__stock-level">
                <a
                  href={`/basket/collections/new?product_id=${id}&quantity=${minimumOrder}`}>
                  Select a Store
                </a>
              </div>
            ) : getBranchStock(id) === 0 ? (
              <div className="product-listings__stock-level product-listings__stock-level--out-of-stock">
                <strong>Out of Stock</strong>
              </div>
            ) : (
              <div className="product-listings__stock-level">
                {branchStocks && branchStocks.length >= 0 ? (
                  <div>
                    <strong>{getBranchStock(id)}</strong> in stock
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            )}
          </div>
        ) : (
          <div className="product-listings__stock-box fl fl-col jc-c">
            <strong className="product-listings__stock-title">
              Collection
            </strong>
            <div className="product-listings__stock-level">Not Available</div>
          </div>
        )}
      </div>
    );
  }
}

export default ProductStock;
